import React from "react";
import "./PatternBackground.css";

export const PatternBackground = React.forwardRef(
  (
    {
      children,
      className = "",
      style,
      contentClassName = "",
      contentStyle,
    },
    ref
  ) => (
    <div
      ref={ref}
      className={["pattern-background", className].filter(Boolean).join(" ")}
      style={style}
    >
      <div
        className={["pattern-content", contentClassName]
          .filter(Boolean)
          .join(" ")}
        style={contentStyle}
      >
        {children}
      </div>
    </div>
  )
);